import { ForwardedRef, useMemo, useState } from "react";
import { PropsWithAs } from "../../types";
import { forwardRefWithGeneric } from "../../utils";
import Card, { CardProps } from "../card";
import CardContext from "./context";

const CollapsibleCard = <T extends React.ElementType = "div">(
  props: PropsWithAs<CardProps & { defaultCollapsed?: boolean }, T>,
  ref: ForwardedRef<any>
) => {
  const { defaultCollapsed, ...rest } = props;
  const [collapsed, setCollapsed] = useState(props.defaultCollapsed ?? false);
  const context = useMemo(
    () => ({ collapsible: true, collapsed, setCollapsed }),
    [collapsed]
  );

  return (
    <CardContext.Provider value={context}>
      <Card {...(rest as PropsWithAs<CardProps, T>)} ref={ref} />
    </CardContext.Provider>
  );
};

export default forwardRefWithGeneric(CollapsibleCard);
